import React, { Component } from "react";
import styles from "./Item.local.scss";
import _ from "i18n";

class WarningList extends Component {
  constructor(props) {
    super(props);
    this.state = { viewMoreWarning: false };
  }

  render() {
    let warnings = this.props.warnings;
    let { viewMoreWarning } = this.state;
    let listWarnings = [];

    warnings.forEach((item, i) => {
      if (i < 3) {
        listWarnings.push(
          <span key={i} className={styles.list__row_group_cell_tag}>
            <span className={styles.client_list_warning}>
              {item !== "" ? _(item) : "No warning"}{" "}
            </span>
          </span>
        );
      } else if (i >= 3 && viewMoreWarning) {
        listWarnings.push(
          <span className={styles.list__row_group_cell_tag}>
            <span className={styles.client_list_warning}>
              {item !== "" ? _(item) : "No warning"}{" "}
            </span>
          </span>
        );
      }
    });

    return (
      <div className={styles.list__row_groups_cell_wrapper}>
        <div> {listWarnings}</div>
        {warnings &&
          warnings.length > 3 && (
            <div
              style={{ bottom: viewMoreWarning ? "-10%" : "" }}
              className={styles.show_more_warning_icon}
              onClick={() =>
                this.setState({ viewMoreWarning: !viewMoreWarning })
              }
            >
              <img
                src={`${
                  viewMoreWarning
                    ? "img/icons/ChevronUp.svg"
                    : "img/icons/ChevronDown.svg"
                }`}
                alt={""}
              />
            </div>
          )}
      </div>
    );
  }
}

export default WarningList;



// WEBPACK FOOTER //
// ./src/components/ClientsList/WarningList.js